import React from 'react';
import BaseComponent from './BaseContainer';
import { withApollo, compose, graphql } from 'react-apollo';
import { Redirect } from 'react-router';
import getGhdSocialNetwork from '../apollo/graphql/ghd-social-network/get';
import getGhdSocialNetworks from '../apollo/graphql/ghd-social-network/getGhdSocialNetworks';
import updateGhdSocialNetwork from '../apollo/graphql/ghd-social-network/update';
import createGhdSocialNetwork from '../apollo/graphql/ghd-social-network/create';
import deleteGhdSocialNetwork from '../apollo/graphql/ghd-social-network/delete';
import GhdSocialNetworkForm from '../components/form/GhdSocialNetwork';

class GhdSocialNetworkContainer extends BaseComponent {
  constructor(props) {
    super(props);

    const isNew =
      props.match.params.objId === 'new' ||
      props.match.params.objId === undefined;

    this.state = {
      status: {
        loading: true,
        message: null,
        error: null,
        isNew: isNew,
        deletion: { confirm: false },
      },
      obj: {
        name: '',
        url: '',
      },
      languages: [],
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  componentDidMount() {
    if (!this.state.status.isNew) {
      this.props.client
        .query({
          query: getGhdSocialNetwork,
          variables: { id: this.props.match.params.objId },
        })
        .then(({ data }) => {
          if (getGhdSocialNetwork.error) {
            this.setState({
              status: {
                ...this.state.status,
                error: true,
                message: getGhdSocialNetwork.error.message,
              },
            });
          }

          const newObject = {
            ...this.state.obj,
            ...data.getGhdSocialNetwork,
          };
          this.setState({
            ...this.state,
            status: {
              ...this.state.status,
              loading: false,
            },
            obj: {
              ...this.state.obj,
              ...newObject,
              translations: {
                ...this.state.obj.translations,
                ...newObject.translations,
              },
            },
          });
        });
    } else {
      this.setState({
        ...this.state,
        status: {
          ...this.state.status,
          loading: false,
        },
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    let newState = {
      status: { ...this.state.status },
    };
    newState.status.loading = false;
    this.setState(newState);
  }

  handleChange(event, data, type) {
    let newState = {
      obj: {
        ...this.state.obj,
      },
    };
    if (type === 'dropdown') {
      //dropdown
      newState.obj[data.id] = data.value;
    } else if (type === 'checkbox') {
      newState.obj[data.id] = data.checked;
    } else if (data === parseInt(data, 10)) {
      //translations data
      newState.obj.translations[data][event.target.id] = event.target.value;
    } else if (event.target.files && event.target.files.length > 0) {
      //files
      newState.obj[event.target.id] = event.target.files[0];
    } else {
      //simple data
      newState.obj[event.target.id] = event.target.value;
    }
    this.setState(newState);
  }

  handleSubmit(event) {
    event.preventDefault();
    this.setState({
      status: {
        ...this.state.status,
        loading: true,
      },
    });
    const obj = this.state.obj;
    delete obj.translations;

    this.state.status.isNew
      ? this.props
          .createGhdSocialNetwork({
            variables: {
              input: obj,
            },
          })
          .then((data) => {
            this.setState({
              status: {
                ...this.state.status,
                loading: false,
                message: `Création effectuée le ${new Date(
                  Date.now(),
                ).toLocaleString()}`,
                isNew: false,
              },
              obj: {
                ...this.state.obj,
                id: data.data.createGhdSocialNetwork.id,
              },
              redirect: true,
            });
          })
          .catch((error) => {
            this.setState({
              status: {
                ...this.state.status,
                loading: false,
                message: error.message,
                error: true,
                isNew: true,
              },
            });
          })
      : this.props
          .updateGhdSocialNetwork({
            variables: {
              input: obj,
            },
          })
          .then(({ data, errors }) => {
            if (errors) {
              this.setState({
                status: {
                  ...this.state.status,
                  loading: false,
                  errors: errors,
                },
              });
            } else {
              this.setState({ redirect: true });
            }
          });
  }

  handleDelete(event, data) {
    event.preventDefault();
    let newState = {
      status: {
        ...this.state.status,
        deletion: {},
      },
    };
    switch (data.confirm) {
      case true:
        newState.status.deletion.confirm = true;
        break;
      case null:
        newState.status.deletion.confirm = false;
        break;
      case false:
        newState.status.deletion.confirm = false;
        this.props
          .deleteGhdSocialNetwork({ variables: { id: this.state.obj.id } })
          .then(this.setState({ redirect: true }))
          .catch((error) => {
            this.setState({
              status: {
                ...this.state.status,
                loading: false,
                message: error.message,
                error: true,
              },
            });
          });
        break;
      default:
        break;
    }
    this.setState(newState);
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/social-networks" />;
    }

    return (
      <GhdSocialNetworkForm
        obj={this.state.obj}
        status={this.state.status}
        onChange={this.handleChange}
        onSubmit={this.handleSubmit}
        onDelete={this.handleDelete}
      />
    );
  }
}

const GhdSocialNetworkContainerEnhanced = compose(
  graphql(updateGhdSocialNetwork, { name: 'updateGhdSocialNetwork' }),
  graphql(createGhdSocialNetwork, { name: 'createGhdSocialNetwork' }),
  graphql(deleteGhdSocialNetwork, {
    name: 'deleteGhdSocialNetwork',
    options: {
      update: (proxy, { data }) => {
        const socialNetworks = proxy.readQuery({ query: getGhdSocialNetworks });
        socialNetworks.getGhdSocialNetworks =
          socialNetworks.getGhdSocialNetworks.filter(
            (obj) => obj.id !== data.deleteGhdSocialNetwork.id,
          );
        proxy.writeQuery({ query: getGhdSocialNetworks, data: socialNetworks });
      },
    },
  }),
)(GhdSocialNetworkContainer);

export default withApollo(GhdSocialNetworkContainerEnhanced);



// WEBPACK FOOTER //
// ./src/containers/GhdSocialNetworkContainer.js